module.exports = __webpack_public_path__ + "static/media/wine-stroll-flyer-2018.87f6beb9.pdf";